var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapTileVault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-tile-vault") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 72.5,
    cy: 57.5,
    r: 41.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-tile-vault"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-Map-Icon-Circle-Default",
    transform: "translate(2.000000, 16.000000)",
    fillOpacity: 0.1,
    fill: "#2E8FFA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Square",
    transform: "translate(3.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9246481,0.728520014 L137.960144,23.2411971 C140.679952,24.2125571 140.679952,25.7874429 137.960144,26.7588029 L74.9246481,49.27148 C72.2048401,50.24284 67.7951599,50.24284 65.0753519,49.27148 L2.03985604,26.7588029 C-0.679952013,25.7874429 -0.679952013,24.2125571 2.03985604,23.2411971 L65.0753519,0.728520014 C67.7951599,-0.242840005 72.2048401,-0.242840005 74.9246481,0.728520014 Z",
    id: "Rectangle-2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vault",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1191306,30.493633 L25.1191306,55.0761809 L1.45597479,45.0444519 C0.618978974,44.5829326 0.200481066,43.4912262 0.200481066,41.7693328 C0.200481066,40.0474394 0.200481066,32.9800732 0.200481066,20.5672342 C0.362310572,19.6115519 0.780808479,18.7757437 1.45597479,18.0598097 C2.67666106,18.6531735 11.2356488,19.0014981 24.4721703,26.535763 C24.9597799,26.8133118 25.1754334,28.1326018 25.1191306,30.493633 Z",
    id: "Path-18",
    fill: "#93A1AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1191593,28.2892299 L65.5181802,10.3889882 L42.8970146,0.545593059 C41.7898903,0.0596976093 40.7647639,0.0596976093 39.8216351,0.545593059 C38.8785064,1.03148851 26.5044283,6.44100046 2.69940092,16.7741289 C2.03289852,17.1027887 1.49326056,17.503321 1.08048702,17.9757258 C2.64463262,18.6300216 10.6575234,22.0678563 25.1191593,28.2892299 Z",
    id: "Path-52",
    fill: "#BCC5CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7149748,10.5292443 C66.232953,11.0628222 66.4919421,12.102764 66.4919421,13.6490699 L66.4919421,35.6692704 C66.1967502,37.1053281 65.2706399,38.1780677 63.7136111,38.887489 C62.1565822,39.5969103 49.9995661,44.8825643 27.2425627,54.7444509 C26.3805034,55.1854551 25.7667581,55.1854551 25.4013266,54.7444509 C24.8531794,54.0829446 25.0767728,34.2690829 25.0767728,31.4160865 C25.0767728,28.5630902 24.6587056,26.9267367 27.2425627,25.8748161 C29.8264198,24.8228955 64.9380075,9.7288775 65.7149748,10.5292443 Z",
    id: "Path-53",
    fill: "#78868F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6389697,12.8476678 C64.1013455,13.3239688 64.3325335,14.2522782 64.3325335,15.632596 L64.3325335,35.2890405 C64.0690289,36.5709449 63.2423318,37.5285313 61.8524421,38.1617999 C60.4625524,38.7950684 49.6105298,43.5133345 29.2963743,52.316598 C28.5268527,52.7102626 27.9789898,52.7102626 27.6527855,52.316598 C27.1634792,51.726101 27.3630709,34.039156 27.3630709,31.4924143 C27.3630709,28.9456725 26.9898811,27.4849732 29.2963743,26.5459709 C31.6028676,25.6069686 62.9454058,12.1332162 63.6389697,12.8476678 Z",
    id: "Path-53",
    fill: "#698195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3759516,37.1953117 L50.9171802,42.7940857 C36.2337318,35.6420818 28.5091035,31.4639789 27.7432954,30.2597769 C26.9774873,29.055575 27.239526,27.9199172 28.5294114,26.8528034 L34.1282497,24.5669913 L64.3759516,37.1953117 Z",
    id: "Path-58",
    fill: "#303A3E"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-55",
    fill: "#7A868F",
    points: "66.051979 43.2391543 66.051979 65.7961736 63.147754 67.2192808 63.147754 44.4057254"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-54",
    fill: "#BDC5CB",
    points: "30.6353786 27.8394564 66.0337536 43.0709845 62.7258349 44.444086 27.0786825 29.3454498"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-56",
    fill: "#95A1AD",
    points: "63.376939 44.4464835 27.0946298 29.3940854 27.0946298 51.766872 63.376939 67.6083662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7912337,35.7711154 C64.3554153,37.0425059 63.7090194,37.4615253 62.8520461,37.0281734 C61.9950728,36.5948216 52.2654573,32.4176717 33.6631997,24.4967237 C51.5140349,17.139418 61.2436504,13.2283186 62.8520461,12.7634255 C64.4604418,12.2985324 65.1068377,13.0817266 64.7912337,15.113008 L64.7912337,35.7711154 Z",
    id: "Path-57",
    fill: "#545D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8783726,49.9013039 L59.4187072,49.2297005 C61.2784693,49.4083733 62.1447599,49.7815233 62.017579,50.3491505 C61.8903982,50.9167777 61.9539886,54.4266836 62.2083504,60.8788682 C61.4131748,61.4671243 60.8535494,61.7054102 60.5294742,61.5937258 C60.2053991,61.4820414 59.3216985,57.5845675 57.8783726,49.9013039 Z",
    id: "Path-60",
    fill: "#78868F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7803636,50.0804758 C58.7777155,48.9332885 60.3209798,50.1753212 60.7344096,50.4133662 C61.515923,50.8633468 60.8180657,58.4915732 60.7344096,60.5315043 C60.6507535,62.5714354 58.196242,61.4163683 57.5366662,60.9933253 C56.8770904,60.5702822 57.5208411,50.3789871 57.7803636,50.0804758 Z",
    id: "Path-59",
    fill: "#BCC5CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6765821,45.0056311 L46.489769,43.4593082 C46.0240672,42.5088958 45.4512451,42.02054 44.7713025,41.9942409 C44.0913599,41.9679418 43.4562667,42.0172884 42.866023,42.1422806 L42.866023,43.9736414 L44.3978902,45.4381727 L46.6765821,45.0056311 Z",
    id: "Path-2",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7013546,45.2798421 L46.8295977,44.9046511 C47.2561868,45.2922892 47.5859381,45.5802573 47.8188514,45.7685552 C48.0517647,45.9568531 48.4646073,46.4531772 49.0573793,47.2575275 C50.1783529,49.0735948 50.4886147,50.3871207 49.9881648,51.198105 C49.23749,52.4145814 47.1049687,53.232605 46.269301,53.1422375 C45.7121892,53.0819926 43.7321131,50.0731394 40.3290728,44.115678 C41.5475884,43.7091854 42.313427,43.6075622 42.6265885,43.8108085 C42.9397499,44.0140549 43.2517706,44.3786691 43.5626504,44.9046511 L44.7013546,45.2798421 Z",
    id: "Path-61",
    fill: "#F5A623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3131338,39.7261184 C43.5338832,39.8240433 43.712836,40.0379472 43.712836,40.2038859 L43.712836,41.4057208 C43.712836,41.5716596 43.5338832,41.6267957 43.3131338,41.5288707 C43.0923845,41.4309458 42.9134317,41.2170419 42.9134317,41.0511032 L42.9134317,39.8492683 C42.9134317,39.6833295 43.0923845,39.6281934 43.3131338,39.7261184 Z",
    id: "Rectangle-2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3131338,54.8639278 C43.5338832,54.9618528 43.712836,55.1757566 43.712836,55.3416954 L43.712836,56.5435302 C43.712836,56.709469 43.5338832,56.7646051 43.3131338,56.6666802 C43.0923845,56.5687552 42.9134317,56.3548514 42.9134317,56.1889126 L42.9134317,54.9870777 C42.9134317,54.821139 43.0923845,54.7660029 43.3131338,54.8639278 Z",
    id: "Rectangle-2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0558003,53.121032 C55.0558003,53.2869708 54.8768476,53.3421069 54.6560982,53.2441819 L53.0572898,52.5349467 C52.8365404,52.4370217 52.6575877,52.2231179 52.6575877,52.0571791 C52.6575877,51.8912404 52.8365404,51.8361043 53.0572898,51.9340292 L54.6560982,52.6432645 C54.8768476,52.7411894 55.0558003,52.9550932 55.0558003,53.121032 Z",
    id: "Rectangle-2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9178781,44.3313362 C34.9178781,44.497275 34.7389253,44.5524111 34.518176,44.4544861 L32.9193675,43.7452509 C32.6986182,43.6473259 32.5196654,43.4334221 32.5196654,43.2674833 C32.5196654,43.1015446 32.6986182,43.0464085 32.9193675,43.1443334 L34.518176,43.8535687 C34.7389253,43.9514936 34.9178781,44.1653974 34.9178781,44.3313362 Z",
    id: "Rectangle-2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4629277,42.2646436 C44.1251758,42.5584185 44.662034,43.2001299 44.662034,43.6979462 L44.662034,46.101616 C44.662034,46.5994323 44.1251758,46.7648406 43.4629277,46.4710657 C42.8006795,46.1772909 42.2638213,45.5355794 42.2638213,45.0377631 L42.2638213,42.6340934 C42.2638213,42.1362771 42.8006795,41.9708688 43.4629277,42.2646436 Z",
    id: "Rectangle",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5622864,52.5145515 C46.4320283,53.7875759 48.7584138,53.0708067 48.7584138,50.9136027 C48.7584138,48.7563987 46.4320283,45.9756492 43.5622864,44.7026248 C40.6925445,43.4296004 38.366159,44.1463696 38.366159,46.3035736 C38.366159,48.4607776 40.6925445,51.2415271 43.5622864,52.5145515 Z",
    id: "Oval-7",
    fill: "#EECA12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4124926,51.70409 C45.8407357,52.7812645 47.8092157,52.1747675 47.8092157,50.349441 C47.8092157,48.5241145 45.8407357,46.1711726 43.4124926,45.0939982 C40.9842494,44.0168237 39.0157694,44.6233207 39.0157694,46.4486471 C39.0157694,48.2739736 40.9842494,50.6269155 43.4124926,51.70409 Z",
    id: "Oval-7",
    fill: "#F3E07E"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapTileVault);
export default __webpack_public_path__ + "static/media/map-tile-vault.8f807f77.svg";
export { ForwardRef as ReactComponent };